import Translate from '../../i18n/Translate'

//Intersection
import { useInView } from 'react-intersection-observer'

const ManualCard = ({ title, subtitle, img, href }) => {
    const [card, inView] = useInView({
        threshold: 1,
        rootMargin: '-130px 0px -70px 0px',
    })

    const backgroundStyle = {
        background: `linear-gradient(rgba(0,0,0,0) 0, rgba(0,0,0,0.4)) 60%, url(${img})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
    }

    return (
        <div className={`manual-card ${inView ? 'in-view' : ''}`} style={backgroundStyle} ref={card} tabIndex={0}>
            <div className="text-content">
                <h2>{title}</h2>
                <p>{subtitle}</p>
            </div>
            <div className="btn-container">
                <a href={href} target="_blank" rel="noreferrer" className="button">
                    <Translate langkey="tourbooks.cards.button1" />
                </a>
                <a href={href} className="button" download>
                    <Translate langkey="tourbooks.cards.button2" />
                </a>
            </div>
        </div>
    )
}

export default ManualCard
